export const uses = [
  {
    img: "container.svg",
    name: "تیم اختصاصی مدیریت بحران",
    desc: "یک تیم فنی مجرب، مسئول طراحی، اجرا و مدیریت بازیابی از بحران سازمان شما خواهد بود و در زمان وقوع بحران نیز در کنار تیم‌تان می‌ماند.",
    alt: "تیم اختصاصی مدیریت بحران",
    title: "تیم اختصاصی مدیریت بحران",
  },
  {
    img: "Isolation.svg",
    name: "طراحی ساختار اهداف بازیابی",
    desc: "مقادیر RPO و RTO بر اساس سطح تحمل اختلال در سازمان شما تعیین می‌شوند و بازیابی از بحران متناسب، توسط تیم متخصصان ابری پیاده‌سازی خواهد شد.",
    alt: "طراحی ساختار اهداف بازیابی",
    title: "طراحی ساختار اهداف بازیابی",
  },
  {
    img: "HA.svg",
    name: "شناسایی منابع حیاتی کسب‌وکار",
    desc: "سیستم‌ها، داده‌ها و سرویس‌های حساس و حیاتی سازمان شما شناسایی شده و روند بازیابی هرکدام در طرح بازیابی از بحران مشخص می‌شود.",
    alt: "شناسایی منابع حیاتی کسب‌وکار",
    title: "شناسایی منابع حیاتی کسب‌وکار",
  },
  {
    img: "plans.svg",
    name: "تحلیل ریسک سازمان شما",
    desc: "سناریوهای بحرانی محتمل شامل حملات سایبری، قطعی زیرساخت یا خطای انسانی به‌دقت شناسایی می‌شوند تا راهکار متناسب با آن‌ها طراحی شود.",
    alt: "تحلیل ریسک سازمان شما",
    title: "تحلیل ریسک سازمان شما",
  },
  {
    img: "service.svg",
    name: "امکان تست دوره‌ای",
    desc: "برای حفظ آمادگی در شرایط واقعی، بازیابی از بحران به‌صورت دوره‌ای تست می‌شود تا میزان کارایی راهکار هنگام بروز بحران ارزیابی شود.",
    alt: "امکان تست دوره‌ای",
    title: "امکان تست دوره‌ای",
  },
];

export const dnsUses = [
  {
    title: "45%",
    desc: "از اختلالات ناخواسته سازمان‌ها ناشی از خرابی سخت‌افزار است.",
  },
  {
    title: "3 ماه",
    desc: "میانگین زمان بازیابی سازمان‌ها بدون برنامه DR پس از وقوع بحران است.",
  },
  {
    title: "40%",
    desc: "از کسب‌وکارهای کوچک پس از یک بحران جدی، هرگز فعالیت خود را از سر نمی‌گیرند.",
  },
  {
    title: "هر ثانیه",
    desc: "اختلال در درگاه‌‌های خدماتی یا فروشگاه‌های آنلاین خسارات جبران‌ناپذیری دارد.",
  },
];

export const scrubbingCenter = [
  {
    title: "مدل Active-Passive",
    desc: "مناسب برای سازمان‌هایی با معماری سنتی و ترکیبی یا آن‌هایی که به‌دنبال راهکاری کم‌هزینه با حداقل منابع فعال هستند",
  },
  {
    title: "مدل Active-Active",
    desc: "بازیابی در لحظه برای سازمان‌هایی با حساسیت بالا نسبت به در دسترس بودن، با اجرای هم‌زمان سرویس‌ها در چند موقعیت",
  },
  {
    title: "استقرار در سراسر کشور",
    desc: "امکان طراحی و پیاده‌سازی راهکار بازیابی از بحران در هر کدام از دیتاسنترهای آبالون در سراسر کشور با اتصال پرسرعت",
  },
  {
    title: "هماهنگ با معماری موجود",
    desc: "پیاده‌سازی کاملاً سازگار با توپولوژی شبکه و سیستم‌های فعلی سازمان شما، بدون نیاز به بازطراحی زیرساخت شما",
  },
];

export const locations = [
  {
    img: "iranServer.svg",
    name: "طراحی Disaster Recovery؛ منطبق بر الزامات پدافند غیرعامل",
    cap: "با بهره‌گیری از بیش از ۲۰ دیتاسنتر فعال در سراسر کشور، آبالون امکان استقرار سایت بازیابی از بحران را در هر نقطه‌ای از ایران فراهم می‌کند. این دیتاسنترها بر اساس الزامات نهادهای نظارتی و مطابق با استانداردهای پدافند غیرعامل طراحی و پیاده‌سازی شده‌اند. در این طراحی، الزامات فنی مانند فاصله جغرافیایی مناسب با سایت اصلی و ایزولاسیون شبکه‌ای به‌طور کامل رعایت می‌شود.",
    alt: "طراحی Disaster Recovery؛ منطبق بر الزامات پدافند غیرعامل",
    title: "طراحی Disaster Recovery؛ منطبق بر الزامات پدافند غیرعامل",
    class: "iranImg",
  },

  {
    img: "externalServer.svg",
    name: "پیاده‌سازی بازیابی از بحران؛ بر بستر امن و اختصاصی نورونتا",
    cap: "آبالون با تکیه بر شبکه ارتباطی نورونتا، بستر ارتباطی اختصاصی و ایزوله از اینترنت عمومی را برای انتقال امن و پرسرعت داده‌ها بین سرور‌های سازمان و دیتاسنترهای DR فراهم می‌کند. این لینک غیر اشتراکی، برای سناریوهای Active-Active و Active-Passive ایده‌آل بوده و با پوشش در بیش از ۹۰۰ شهر کشور، امکان ارائه سرعتی تا چند ده گیگابیت بر ثانیه را دارد.",
    alt: "پیاده‌سازی بازیابی از بحران؛ بر بستر امن و اختصاصی نورونتا",
    title: "پیاده‌سازی بازیابی از بحران؛ بر بستر امن و اختصاصی نورونتا",
    class: "externalImg",
  },
];

export const usage = [
  {
    img: "/virtualServer/virtualDesktop.svg",
    title: "جلوگیری از خطاهای زیرساخت",
    desc: "با انتقال داده‌ها به کلاسترهای پشتیبان و تکثیر هم‌زمان آن‌ها در دیتاسنتر اصلی، خطر از بین رفتن اطلاعات کاهش می‌یابد. در صورت خرابی سخت‌افزار یا قطعی بخشی از سیستم، سرویس‌دهی بدون اختلال ادامه پیدا می‌کند.",
    imgAlt: "جلوگیری از خطاهای زیرساخت",
    imgTitle: "جلوگیری از خطاهای زیرساخت",
  },

  {
    img: "/devops/icons/test.svg",
    title: "بازیابی از راه دور",
    desc: "در صورت بروز بحران‌های گسترده نظیر آتش‌سوزی، سیل یا قطع برق منطقه‌ای، داده‌های تکرارشده در دیتاسنترهای DR فعال می‌شوند تا با حداقل RTO و RPO، سرویس‌ها در کوتاه‌ترین زمان به حالت عملیاتی بازگردند.",
    imgAlt: "بازیابی از راه دور",
    imgTitle: "بازیابی از راه دور",
  },
  {
    img: "/virtualServer/backup.svg",
    title: "بازگردانی از نسخه‌های پایدار",
    desc: "در مواجهه با خطاهای منطقی مانند حذف اشتباهی اطلاعات، باج‌افزار یا حملات امنیتی، امکان فعال‌سازی قابلیت Snapshot و Backup برای بخش‌های منتخب زیرساخت وجود دارد این قابلیت به درخواست مشتری فعال‌سازی و پیکربندی می‌شود.",
    imgAlt: "بازگردانی از نسخه‌های پایدار",
    imgTitle: "بازگردانی از نسخه‌های پایدار",
  },
];

export const popularServices = [
  {
    title: "دیتاسنتر ابری",
    desc: "دیتاسنتر ابری امکانات یک دیتاسنتر فیزیکی قوی را روی ابرها فراهم می‌کند و می‌تواند پاسخی برای پیچیده‌ترین و تخصصی‌‌ترین نیازهای سازمان شما باشد.",
    logo: "VPC-Service.svg",
    route: "/vpc",
  },
  {
    title: "شبکه توزیع محتوا (CDN)",
    desc: "با استفاده از CDN، امنیت و سرعت بارگذاری وب‌سایت خود را بهبود دهید. داده‌های شما از طریق سرورهای توزیع‌شده همیشه نزدیک‌تر به کاربران خواهند بود.",
    logo: "CloudGuard-Service.svg",
    route: "/cdn",
  },
  {
    title: "سرور اختصاصی",
    desc: "با خرید سرور اختصاصی آبالون، به منابع سخت‌افزاری قدرتمند در دیتاسنترهای پیشرفته سراسر کشور به‌صورت Bare Metal یا با معماری ابری دسترسی داشته باشید.",
    logo: "VPS-Service.svg",
    route: "/dedicated-server",
  },
  {
    title: "PAM ابری آبالون",
    desc: "با استفاده از راهکار PAM ابری آبالون، بدون نیاز به زیرساخت داخلی، دسترسی کاربران به سیستم‌عامل‌ها و نرم‌افزارهای سازمانی را به‌صورت ایمن و متمرکز مدیریت و تمام فعالیت‌ها را ثبت و کنترل کنید.",
    logo: "ManagedService-Service.svg",
    route: "/pam",
  },
];

export const questions = [
  {
    title: "امکان انتخاب محل دیتاسنتر بازیابی از بحران چگونه فراهم می‌شود؟",
    answer:
      "آبالون با در اختیار داشتن بیش از ۲۰ دیتاسنتر در سراسر کشور، این امکان را فراهم می‌کند که سرویس DR در مکان‌هایی با فاصله جغرافیایی مناسب و مطابق الزامات پدافند غیرعامل طراحی و پیاده‌سازی شود.",
  },
  {
    title: "راهکار بازیابی از بحران آبالون برای چه سازمان‌هایی مناسب است؟",
    answer:
      "راهکار بازیابی از بحران آبالون برای سازمان‌هایی مناسب است که نیاز به تداوم خدمات در شرایط بحرانی و حفظ دسترسی به داده‌های خود دارند. این راهکار بر اساس معماری زیرساخت سازمان قابل پیاده‌سازی است.",
  },
  {
    title:
      "آیا امکان پیاده‌سازی سناریوهای Active-Active و Active-Passive وجود دارد؟",
    answer:
      "بله، آبالون با توجه به نیاز و مقیاس سازمان‌ها، امکان راه‌اندازی سناریوهای Active-Active و Active-Passive را در راهکار بازیابی از بحران فراهم می‌کند تا سرویس‌ها در زمان وقوع اختلال بدون توقف یا با کمترین توقف ادامه پیدا کند.",
  },
  {
    title:
      "آیا امکان استفاده از لینک ارتباطی سریع برای انتقال داده بین سایت اصلی و سایت DR وجود دارد؟",
    answer:
      "بله، آبالون با بهره‌گیری از شبکه اختصاصی نورونتا، امکان ارائه لینک‌های ارتباطی ایزوله و غیر اشتراکی با سرعت بالا تا چند ده گیگابیت بر ثانیه را بین دیتاسنترها یا از محل سازمان تا دیتاسنتر فراهم نموده است. این قابلیت برای سناریوهای Active-Active و Active-Passive ایده‌آل است.",
  },
];
